import { OnInit, Component, Input, Attribute } from "@angular/core";
import { INode } from "../../Configuration/INode";
import { OxeModelService } from "../../oxe-model-service/oxe-model.service";
import { ApplicationService } from "../../application-service/application.service";
import { LoggerService } from "../../logger-service/logger.service";
import { ErrorNotificationService } from "../../error/error-notification.service";
import { TranslateService } from "@ngx-translate/core";
import { NotificationsService, NotificationType } from "angular2-notifications";
import { BehaviorSubject ,  Observable } from "rxjs";
import { ConfigSearchService } from "./config-search.service";

@Component({
    selector: "wbm-config-search",
    templateUrl: "config-search.component.html",
    styleUrls: ['../../../assets/theme/css/ConfigSearch.css']
})
export class ConfigSearchComponent implements OnInit {

    @Input() public rootNode1: INode;
    searchResult = [];
    searchStarted = true;
    public isDisabled: boolean = true

    private nodeToSearch = "";
    constructor(public _oxeModel: OxeModelService,
        private _appliservice: ApplicationService,
        private _logger: LoggerService,
        private _errorNotification: ErrorNotificationService,
        private _notification: NotificationsService,
        private _translate: TranslateService,
        private _searchservice: ConfigSearchService) {
    }

    ngOnInit() {
        this._translate.get('param_name_search')
            .subscribe((message) => {
                (<HTMLInputElement>document.getElementById("searchField")).placeholder = message;
            })

        this._translate.get('search_not_in_DB')
            .subscribe((message) => {
                (<HTMLInputElement>document.getElementById("searchButton")).title = message;
            })
    }

    public valueChange(event) {
        console.log("valueChange", event);
        this.nodeToSearch = event.target.value;
        /* if (this.nodeToSearch.trim().length >= 3)
            (document.getElementById("searchButton") as HTMLButtonElement).disabled = false;
        else
            (document.getElementById("searchButton")as HTMLButtonElement).disabled = true; */
        this.searchStarted = true;
        this.searchResult = [];
        //this.search();
    }

    public search() {
        if (this.nodeToSearch.trim() === "" || this.nodeToSearch.trim().length < 3) {
            /* this._notification.error("Validation Failed", "Enter Min. 3 Characters to search"); */
            this._translate.get(["min_char_required", "invalid-data"])
                .subscribe((translatedMessage) => {
                    this._notification.error(translatedMessage["invalid-data"], translatedMessage["min_char_required"]);
                });
            return;
        }
        this._oxeModel.setLoader(true);
        var self = this;
        setTimeout(() => {
            console.log("search started for", self.nodeToSearch);
            // To get the nodes to search from dict, Node wil be searched with the Key value not teh dict/translated value
            let searchNode = this.getKeyByValue(self._appliservice.dict, self.nodeToSearch.trim()).map(x => x.toLowerCase());
            console.log("search started for keys", searchNode);
            let subnodes = self.rootNode1.subNodes;
            let attributes;
            let canLocateChild = false;
            if (self.searchResult.length == 0 && self.searchStarted) {
                self.searchStarted = true;
                subnodes.forEach(schemaNode => {
                    attributes = schemaNode.attributes;
                    console.log("schemaNode", schemaNode);

                    let searchHierachyNode = [];
                    let searchHierachyAttr = [];
                    let searchHierachyValue = [];
                    if (searchNode.indexOf(schemaNode.name.toLowerCase()) > -1) {
                        searchHierachyNode.push({
                            "name": schemaNode.name,
                            "type": "Node",
                            "canLocate": true
                        });
                        self.searchResult.push({ "canLocate": true, "searchHierachy": [...searchHierachyNode], "type": "Node" });
                    }

                    attributes.forEach((attribute) => {
                        if (!attribute.isMask) {
                            if (searchNode.indexOf(attribute.name.toLowerCase()) > -1) {
                                searchHierachyAttr = [];
                                searchHierachyAttr.push({
                                    "name": schemaNode.name,
                                    "type": "Node",
                                    "canLocate": true
                                });
                                searchHierachyAttr.push({
                                    "name": attribute.name,
                                    "type": "Attribute",
                                    "canLocate": false
                                });
                                self.searchResult.push({ "canLocate": false, "searchHierachy": [...searchHierachyAttr], "type": "Attribute" });
                            }

                            // To search the attribute values of the Enumerated attributes
                            if (attribute['structure']['type']['name'] === "Enumerated") {
                                let attrValues = attribute['structure']['type']['values'].map(x => x.toLowerCase());

                                attrValues.forEach((attrValue) => {
                                    if (searchNode.indexOf(attrValue.toLowerCase()) > -1) {
                                        searchHierachyValue = []
                                        searchHierachyValue.push({
                                            "name": schemaNode.name,
                                            "type": "Node",
                                            "canLocate": true
                                        });
                                        searchHierachyValue.push({
                                            "name": attribute.name,
                                            "type": "Attribute",
                                            "canLocate": false
                                        });
                                        searchHierachyValue.push({
                                            "name": attrValue,
                                            "type": "Attrvalue",
                                            "canLocate": false
                                        });
                                        self.searchResult.push({ "canLocate": false, "searchHierachy": [...searchHierachyValue], "type": "Attrvalue" });
                                    }
                                })
                            }

                            // To search the 2nd level attributes in case of complex attributes
                            if (attribute.structure.type != undefined) {
                                let tempAttr = []
                                tempAttr.push({
                                    "name": schemaNode.name,
                                    "type": "Node",
                                    "canLocate": true
                                });
                                tempAttr.push({
                                    "name": attribute.name,
                                    "type": "Attribute",
                                    "canLocate": false
                                });
                                searchAttribute([...tempAttr], attribute.structure['type'], searchNode);
                            }
                        }
                    })
                    // To search through the child nodes
                    let tempNode = []
                    tempNode.push({
                        "name": schemaNode.name,
                        "type": "Node",
                        "canLocate": true
                    })
                    if (schemaNode.isCreatable)
                        canLocateChild = false;
                    else
                        canLocateChild = true;
                    searchChild([...tempNode], schemaNode.structure ? schemaNode.structure['subClasses'] : schemaNode['subClasses'], searchNode, canLocateChild);
                });
            }

            console.log("searchResult=>", self.searchResult);
            self._searchservice.finalResult = [...self.searchResult];
            self._searchservice.showSearch = true;
            self._oxeModel.setLoader(false);
        }, 500);

        function searchChild(parentHier, subclasses, searchNode, canLocate) {
            let canLocateAttr = false;
            if (subclasses != undefined && subclasses != null) {
                let subClassesArray = Object.keys(subclasses)/* .map(i => subclasses[i]) */;
                let canLocateChild1 = false;
                let searchHierachy = [...parentHier];
                subClassesArray.forEach(subClass => {
                    if (searchNode.indexOf(subClass.toLowerCase().toLowerCase()) > -1) {
                        /* if (subClass.toLowerCase() === searchElement.toLowerCase()) { */
                        let tempNode = [...searchHierachy]
                        tempNode.push({
                            "name": subClass,
                            "type": "Node",
                            "canLocate": canLocate
                        });
                        self.searchResult.push({ /* "canLocate": canLocateChild,  */"searchHierachy": [...tempNode], "type": "Node" });
                    }

                    let attributes = subclasses[subClass].attributes;

                    Object.keys(attributes).forEach((attrName) => {
                        let isMask = false;
                        if (attributes[attrName].mask != undefined)
                            isMask = attributes[attrName].mask;

                            if(!isMask){
                                if (attrName === subclasses[subClass].id && !subclasses[subClass].create)
                                    canLocateAttr = true;
                                else
                                    canLocateAttr = false;

                                if (searchNode.indexOf(attrName.toLowerCase()) > -1) {
                                    /* if (attrName.toLowerCase() === searchElement.toLowerCase()) { */
                                    let tempNode = [...searchHierachy]
                                    if (includeAttribute(subclasses[subClass], attrName)) {
                                        tempNode.push({
                                            "name": subClass,
                                            "type": "Node",
                                            "canLocate": canLocate
                                        });
                                        tempNode.push({
                                            "name": attrName,
                                            "type": "Attribute",
                                            "canLocate": canLocateAttr
                                        });
                                        self.searchResult.push({ /* "canLocate": false, */ "searchHierachy": /* searchHierachy + "->" + searchElement */[...tempNode], "type": "Attribute" });
                                    }
                                }

                                if (attributes[attrName]['type']['name'] === "Enumerated") {
                                    let attrValues = attributes[attrName]['type']['values'];

                                    attrValues.forEach((attrvalue) => {
                                        if (searchNode.indexOf(attrvalue.toLowerCase()) > -1) {
                                            let tempNode = [...searchHierachy];
                                            tempNode.push({
                                                "name": subClass,
                                                "type": "Node",
                                                "canLocate": canLocate
                                            });
                                            tempNode.push({
                                                "name": attrName,
                                                "type": "Attribute",
                                                "canLocate": canLocateAttr
                                            });
                                            tempNode.push({
                                                "name": attrvalue,
                                                "type": "Attrvalue",
                                                "canLocate": canLocateAttr
                                            });
                                            self.searchResult.push({ "canLocate": false, "searchHierachy": [...tempNode], "type": "Attrvalue" });
                                            /* } */
                                        }
                                    })

                                }
                                if (attributes[attrName].type != undefined) {
                                    let tempNode = [...searchHierachy];
                                    tempNode.push({
                                        "name": subClass,
                                        "type": "Node",
                                        "canLocate": canLocate
                                    });
                                    tempNode.push({
                                        "name": attrName,
                                        "type": "Attribute",
                                        "canLocate": canLocateAttr
                                    });
                                    searchAttribute([...tempNode], attributes[attrName]['type'], searchNode);
                                }
                            }
                    }
                    )
                    let tempNode1 = [...parentHier]
                    tempNode1.push({
                        "name": subClass,
                        "type": "Node",
                        "canLocate": canLocate
                    });
                    if (canLocate)
                        if (subclasses[subClass].create)
                            canLocateChild1 = false;
                        else
                            canLocateChild1 = true;
                    searchChild([...tempNode1], subclasses[subClass].structure ? subclasses[subClass].structure['subClasses'] : subclasses[subClass]['subClasses'], searchNode, canLocateChild1);
                });
            }
        }

        function includeAttribute(subClass, attrName): boolean {
            if (subClass.attributes[subClass.id]['type']['name'] === "Enumerated") {
                let attrValues = subClass.attributes[subClass.id]['type']['values'].map(x => x.toLowerCase());
                if (attrValues.includes(attrName.toLowerCase()))
                    return false;
            }
            return true;
        }

        function searchAttribute(parentHier, attributetype, searchNode, canLocateattr1 = false) {
            let searchHierachy4 = [...parentHier];
            let searchHierachy5 = [...parentHier]
            if (attributetype.name === "Sequence") {
                let childAttributes = attributetype.sequence;
                Object.keys(childAttributes).forEach((key) => {
                    let attrName = key;
                    if (searchNode.indexOf(attrName.toLowerCase()) > -1) {
                        /* if (attrName.toLowerCase() === searchElement.toLowerCase()) { */
                        let tempNode = [...searchHierachy4];
                        tempNode.push({
                            "name": attrName,
                            "type": "Attribute",
                            "canLocate": canLocateattr1
                        });
                        self.searchResult.push({ "canLocate": false, "searchHierachy": [...tempNode], "type": "Attribute" });
                    }

                    if (childAttributes[key].type['name'] === "Enumerated") {
                        let attrValues = childAttributes[key].type['values'];
                        attrValues.forEach((attrValue) => {
                            if (searchNode.indexOf(attrValue.toLowerCase()) > -1) {
                                if (Object.keys(childAttributes).map(s => s.toLowerCase()).indexOf(attrValue.toLowerCase()) == -1) {
                                    let tempNode = [...searchHierachy5];
                                    tempNode.push({
                                        "name": attrName,
                                        "type": "Attribute",
                                        "canLocate": false
                                    });
                                    tempNode.push({
                                        "name": attrValue,
                                        "type": "Attrvalue",
                                        "canLocate": false
                                    });
                                    self.searchResult.push({ "canLocate": false, "searchHierachy": [...tempNode], "type": "Attrvalue" });
                                }
                            }
                        })
                    }

                    let tempVal = [...parentHier];
                    tempVal.push({
                        "name": attrName,
                        "type": "Attribute",
                        "canLocate": false
                    });
                    searchAttribute([...tempVal], childAttributes[key].type, searchNode);
                })
            } else if (attributetype.name === "Byte_String") {
                let searchHierachy6 = [...parentHier];
                let childAttributes = attributetype.digits;
                childAttributes.forEach((childAttribute) => {
                    if (searchNode.indexOf(childAttribute.toLowerCase()) > -1) {
                        let tempNode3 = [...searchHierachy6];
                        tempNode3.push({
                            "name": childAttribute,
                            "type": "Attribute",
                            "canLocate": false
                        });
                        self.searchResult.push({ "canLocate": false, "searchHierachy": [...tempNode3], "type": "Attribute" });
                    }
                })
            } else if (attributetype.name === "Set_Of") {
                let childAttributes = attributetype.set_of;
                searchAttribute([...parentHier], childAttributes, searchNode);
            }
        }
    }

    getKeyByValue(object, value): string[] {
        let keys = [];
        let dictKeys = Object.keys(object);
        dictKeys.forEach(key => {
            if (object[key].toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""))) {
                keys.push(key);
            }
        })
        return keys;
    }

    getKeyStartsByValue(object, value): string {
        let a = Object.keys(object).find(key => object[key].startsWith(value));
        /* if (a != undefined)
            return a;
        else
            return value; */
        return a;
    }

    private notifySuccess(operationTypeMessage: string) {
        this._translate.get(operationTypeMessage)
            .subscribe((translatedMessage) => {
                this._notification.html(
                    `<aside class="flex-container nowrap flex-align-center notification notification--success icon__svg">
                    <span class="flex-item-fluid pas">` + translatedMessage + `</span>
                </aside>`, NotificationType.Bare);
            });
    }
}